import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "../../lib/whatsapp";
import { trackWhatsAppClickConversion } from "../../lib/gtag";

export const WhatsAppFloat = ({ number }) => {
  if (!number) return null;
  const message = "Hola, me gustaría más información sobre sus servicios de fotografía y video.";
  return (
    <a
      href={buildWhatsAppLink(number, message)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={trackWhatsAppClickConversion}
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-twp-gold text-black shadow-[0_8px_30px_rgba(212,175,55,0.5)] hover:scale-110 transition-transform duration-300"
    >
      <MessageCircle size={26} strokeWidth={2} />
    </a>
  );
};
